var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcelFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3531 4.50938L9.99063 1.14688C9.89688 1.05313 9.77031 1 9.6375 1H3C2.72344 1 2.5 1.22344 2.5 1.5V14.5C2.5 14.7766 2.72344 15 3 15H13C13.2766 15 13.5 14.7766 13.5 14.5V4.86406C13.5 4.73125 13.4469 4.60313 13.3531 4.50938ZM12.3469 5.09375H9.40625V2.15313L12.3469 5.09375ZM12.375 13.875H3.625V2.125H8.34375V5.5C8.34375 5.67405 8.41289 5.84097 8.53596 5.96404C8.65903 6.08711 8.82595 6.15625 9 6.15625H12.375V13.875ZM8.03281 9.06406L7.06719 7.46406C7.03281 7.40781 6.97188 7.37344 6.90625 7.37344H6.30625C6.27031 7.37344 6.23594 7.38281 6.20625 7.40312C6.11875 7.45781 6.09219 7.57344 6.14844 7.6625L7.43437 9.7L6.13125 11.775C6.11354 11.8035 6.10376 11.8361 6.10292 11.8696C6.10208 11.9031 6.1102 11.9363 6.12645 11.9656C6.1427 11.9949 6.16649 12.0193 6.19535 12.0364C6.22422 12.0534 6.25711 12.0624 6.29063 12.0625H6.82969C6.89531 12.0625 6.95469 12.0281 6.98906 11.9734L7.96875 10.3875L8.94219 11.9719C8.97656 12.0281 9.0375 12.0609 9.10156 12.0609H9.6875C9.72344 12.0609 9.75781 12.05 9.78906 12.0312C9.87656 11.975 9.90156 11.8594 9.84531 11.7719L8.53281 9.73438L9.86563 7.66406C9.88367 7.63569 9.89377 7.60299 9.89489 7.56939C9.89601 7.53578 9.88811 7.50249 9.87199 7.47298C9.85588 7.44346 9.83215 7.41881 9.80328 7.40158C9.7744 7.38435 9.74144 7.37517 9.70781 7.375H9.15C9.08437 7.375 9.02344 7.40937 8.98906 7.46562L8.03281 9.06406Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excel-file.774e89f3da6b0adde78d5382ae5fd0c9.svg";
export { ForwardRef as ReactComponent };